// メニュー展開
$(document).on('click', '.a-js-search', function() {
  $('#drawer-search').toggleClass('open');
  $('#overlay').toggleClass('open');
  $('body').toggleClass('open');
  return false;
});

$(document).on('click', '.a-js-service', function() {
  $('#drawer-service').toggleClass('open');
  $('#overlay').toggleClass('open');
  $('body').toggleClass('open');
  return false;
});



// ハンバーガーメニュー展開
$(document).on('click', '.menuToggle', function() {
  $('#drawer').toggleClass('open');
  $('#overlay').toggleClass('open');
  $('body').toggleClass('open');
  return false;
});

$(document).on('click', '.menuClose', function() {
  $('#drawer').removeClass('open');
	$('#drawer-search').removeClass('open');
	$('#drawer-service').removeClass('open');
  $('#overlay').removeClass('open');
  $('body').removeClass('open');
  return false;
});


// ヘッダースティッキー
if(document.querySelector('.sticky-header_all') != null){
	const sticky_header_all = document.querySelector('.sticky-header_all');
	const sticky_padding = document.querySelector('.sticky_padding');
	let sticky_header_allTop = sticky_header_all.getBoundingClientRect();
	let sticky_header_allTop_position = sticky_header_allTop.top + window.pageYOffset;
	let sticky_header_all_height = sticky_header_all.clientHeight;
	let sticky_header_Animation = function() {
		let header_scroll_position = window.pageYOffset;
		if(header_scroll_position > sticky_header_allTop_position){
  		sticky_header_all.classList.add('sticky_on');
		sticky_padding.style.paddingTop = sticky_header_all_height + "px";
        sticky_padding.classList.add('sticky_on');
 		}  else {
  		sticky_header_all.classList.remove('sticky_on');
		sticky_padding.style.paddingTop = "0";
        sticky_padding.classList.remove('sticky_on');
 		}
	}
	 window.addEventListener('scroll', sticky_header_Animation);
}


// フッターTOPに戻る
if(document.getElementById("side_to_top_btn_sec2") != null){
	const pageTop =  document.getElementById('side_to_top_btn_sec2');
	const pageTopBtn1 =  document.getElementById('side_to_top_btn2');
	let Animation = function() {
	//アイコン位置取得

	//要素の位置座標を取得
	let rect = pageTop.getBoundingClientRect();
	//topからの距離
	let scrollTop = rect.top + window.pageYOffset;

	if(scrollTop > 600){
		pageTop.classList.add('show');
		}  else {
		pageTop.classList.remove('show');
		}
	}
	window.addEventListener('scroll', Animation);
	pageTopBtn1.addEventListener("click", scroll_top);
}

function scroll_top() {
	window.scrollTo(0, 0);
}


// フッターTOPに戻る
if(document.getElementById("side_to_top_btn") != null){
	const pagetopBtn = document.querySelector('#footer_to_top_btn');
	pagetopBtn.addEventListener('click', () => {
		window.scrollTo({
			top: 0,
			behavior: "smooth"
		});
	});
	};
	


// $(function(){
// 	// 検索ボタンを押した時の処理
// 	//検索ボタンを押した際に、検索ボックスの中身に「#a-serach」のvalueを追加する
//   $('.blog-search .search__button').click(function(){
//     var searchWord = $('#a-search').val();
//     var searchBox = $('.blog-search .search__input');
//     var searchBoxVal = searchBox.val();
//     searchBox.val(searchWord + ' ' + searchBoxVal);
//   });
// });

//a-scrollHeaderをページトップからスクロールした際にふわっと表示させる
// $(function(){
// 	var scroll = $(window).scrollTop();
// 	if (scroll >= 100) {
// 		$('.a-scrollHeader').addClass('is-show');
// 	} else {
// 		$('.a-scrollHeader').removeClass('is-show');
// 	}
// 	$(window).scroll(function() {
// 		var scroll = $(window).scrollTop();
// 		if (scroll >= 100) {
// 			$('.a-scrollHeader').addClass('is-show');
// 		} else {
// 			$('.a-scrollHeader').removeClass('is-show');
// 		}
// 	});
// });


// 別ホストのリンクを_blankで開く
window.addEventListener('DOMContentLoaded', function() {
  const links = document.links;
  const linksLength = links.length;
  for (let i = 0; i < linksLength ; i++) {
	if (links[i].hostname !== window.location.hostname) {
	  links[i].target = '_blank';
	  links[i].rel = 'noreferrer noopener';
	}
  }
});




$(function(){
	$('.menu-drawer__navLink').click(function(){
		if ($(this).attr('aria-expanded') == 'false') {
			$(this).attr('aria-expanded', true);
			$(this).next().slideDown();
		} else {
				$(this).attr('aria-expanded', false);
				$(this).next().slideUp();
		}
	});
});

$(function(){
	$('.bottomMenu__box.mega').hover(
	function() {
		//カーソルが重なった時
		$(this).children(".bottomMenu__inner").addClass("active");
	}, function() {
		//カーソルが離れた時
		$(this).children(".bottomMenu__inner").removeClass("active");
	}
);

});

// ナビゲーション　子要素展開
$(function() {
	var ua = navigator.userAgent;
	// タブレット・スマートフォン時
	if ((ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0) && ua.indexOf('Mobile') > 0||ua.indexOf('iPad') > 0) {
		$('.hasChildren > a').on('mouseenter touchstart', function(){
			$(this).toggleClass('open');
			$(this).next('ul,.megaMenu').toggleClass('open');
			return false;
		}).on('mouseleave touchend', function(){
					return false;
		});
		$('.hasChildren .hasChildren--close > a').on('mouseenter touchstart', function(){
			$(this).parents('ul').removeClass('open').prev('a').removeClass('open');
			return false;
		});

	}else{
	// PC時
		$('.hasChildren').hover(function() {
			$(this).children('a').addClass('open');
			$(this).children('ul,.megaMenu').addClass('open');
		}, function() {
			$(this).children('a').removeClass('open');
			$(this).children('ul,.megaMenu').removeClass('open');
		});
	}
});

$(function(){
	var urlHash = location.hash;
	if(urlHash) {
			$('body,html').stop().scrollTop(0);
			setTimeout(function(){
					var target = $(urlHash);
					var position = target.offset().top;
					$('body,html').stop().animate({scrollTop:position}, 0);
			}, 400);
	}
});